import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  align-self: center;
`;

const NoConversationPage: FC = () => {
  return <Container>Veuillez sélectionner une conversation</Container>;
};

export default NoConversationPage;
